import React, { useState } from "react";

import { useToast } from "@/src/lib/hooks/useToast";
import ErrorPopup from "../common/errorPopup";
import CustomButton from "@/src/lib/ui/Button";

const ChangeCentre = ({ visitType, centreUpdateHandler, onSuccess }) => {
    const [error, setError] = useState("");
    const { showToast } = useToast();

    const onClosePopup = () => {
        setError("");
    };

    return (
        <>
            <div>
                <p className="font-bold text-black text-lg">
                    The test is already in your cart for a different center!
                </p>
                <p className="font-normal text-black text-base">
                    Please confirm if you would like to continue booking at old
                    centre or change to new centre?
                </p>

                <div className="flex flex-row gap-2 mt-5">
                    <CustomButton
                        className="w-full capitalize"
                        fullWidth
                        variant="outlined"
                        onClick={() => centreUpdateHandler(`OLD`)}
                    >
                        {`continue for old centre`}
                    </CustomButton>
                    <CustomButton
                        className="w-full capitalize"
                        fullWidth
                        variant="contained"
                        onClick={() => centreUpdateHandler(`NEW`)}
                    >
                        {`switch to new centre`}
                    </CustomButton>
                </div>
            </div>
            <ErrorPopup
                open={!!error}
                onClose={onClosePopup}
                errorMessage={error}
            />
        </>
    );
};

export default ChangeCentre;
